var phonebook = { result: [] };
var phonebookDelayTimer;

function initPhonebookSearch() {
    // Handle search input text input
    $('#phonebook-form .phonebook-input-text').on('input', function () {
        phonebookSearch($(this).val());
    });

    // Search for blank on start
    var query = getUrlParameter("q");
    if (query !== "") {
        $('#phonebook-form .phonebook-input-text').val(query);
    }
    phonebookSearch(query);
}

window.initPhonebookSearch = initPhonebookSearch;

// Use received data to bind to view
function phonebookShowResult(data) {
    phonebook.result = data;

    if (data && data.Error) {
        var errorMsg = $("#phonebook-results").data("error");
        $("#phonebook-results").html('<div class="col-xs-12"><p>' + errorMsg + '</p></div>');
        return;
    }

    if (!data || data.length === 0) {
        var noResultsMsg = $("#phonebook-results").data("noresults");
        $("#phonebook-results").html('<div class="col-xs-12"><p>' + noResultsMsg + '</p></div>');
        return;
    }

    var source = $("#phonebook-template").html();
    var template = Handlebars.compile(source);
    var html = template(phonebook);
    $("#phonebook-results").html(html);
}

// Search for string and handle received data
function phonebookSearch(query) {
    query = query.trim();
    if (query === "") {
        $("#phonebook-results").html("");
        return;
    }
    
    clearTimeout(phonebookDelayTimer);
    phonebookDelayTimer = setTimeout(function () {

        if (history.pushState && query !== "") {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?q=' + query;
            window.history.pushState({ path: newurl }, '', newurl);
        }

        $.getJSON("/api/phonebook/search", { query: query })
            .done(phonebookShowResult)
            .fail(function () {
                var errorMsg = $("#phonebook-results").data("error");
                $("#phonebook-results").html('<div class="col-xs-12"><p>' + errorMsg + '</p></div>');
            });
    }, 250);
}

function getUrlParameter(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || "";
}